import ApplicationShell from "./components/ApplicationShell";
import { startPwaInstallCapture } from "./components/pwaInstall";
import React, { lazy, useEffect, useRef, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import PathDefinitions from "./PathDefinition-Current";
import Login from "./components/account/Login/Login.lazy";

import "./index.css";
import "bootstrap/dist/css/bootstrap.css";

import { loadScript } from "./models/utils";

import { loadLanguage, itx } from "./translationItx/itx";
import { showGlobalWaitIndicator } from "./components/GlobalWaitIndicator";
import EstadaSuspense from "./components/EstadaSuspense";
import ProtectedRoute from "./utils/guards/private-route.guard";
import { isConceptOneHost } from "./conceptOne/C1_host";
import { mountReactApp } from "./reactRoot";
import { onReactRender, startReactWatchdog } from "./reactWatchdog";

const ConceptOneApp = lazy(() => import("./conceptOne/ConceptOneApp"));

startPwaInstallCapture();
startReactWatchdog();

function LazyPanel() {
  return <EstadaSuspense Component={lazy(() => import("./panel/Panel"))} />;
}

const isPanel = location.href.toLowerCase().indexOf("panel") >= 0;

if (window.opener && !isPanel) {
  console.log("index.tsx for second Screen");
  globalThis.state = (window.opener as any)._state;
  (window as any)._state = (window.opener as any)._state;
}

const isDevelopment = location.host.toLowerCase().indexOf("localhost") >= 0;
if (!isDevelopment) {
  try {
    window.localStorage.setItem("debug", "*");

    if (!(window as any).isInstall && !(window as any).isPanel) {
      console.log("init LO");
      (window as any).LOQ = (window as any).LOQ || [];
      (window as any).LOQ.push([
        "ready", // no itx
        async (LO) => {
          // Track an event
          await LO.$internal.ready("events");
          console.log("LO events are ready");
          LO.events.track("Init"); // no itx
        },
      ]);

      // loadScript("https://tools.luckyorange.com/core/lo.js?site-id=c63a50e2").then(() => {
      //   try {
      //     // console.log("luckyorange initilaized", window.LO);
      //     // LO.events.track("Init", {});
      //     // console.log("luckyorange events Init send");
      //   } catch (ex) {}
      // });
    }
  } catch (ex) {}
}

let recordingLoaded = false;

function XStrict(params: { children: any }) {
  const { children } = params;
  const useStrict = false;

  if (useStrict) {
    return <React.StrictMode>{children}</React.StrictMode>;
  } else {
    return <>{children}</>;
  }
}

function Root() {
  // On a controlled React-root restart the module-level language initialization is
  // already complete, so the freshly mounted Root must not remain on the loading screen.
  const [languageLoaded, setLanguageLoaded] = useState(recordingLoaded);

  useEffect(() => {
    if (!recordingLoaded) {
      // Load session recording
      recordingLoaded = true;

      loadLanguage().then(() => setLanguageLoaded(true));
    }
  }, []);

  if (!languageLoaded) {
    showGlobalWaitIndicator(true, itx("homePage.loading", "loading..."));
    return <div></div>;
  }

  if (isPanel) {
    return <LazyPanel />;
  }

  return (
    <XStrict>
      <ApplicationShell>
        <RouterProvider router={isConceptOneHost() ? conceptOneRouter : router} />
      </ApplicationShell>
    </XStrict>
  );
}

const pathDefinitionsX = PathDefinitions().concat([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/concept-one",
    element: (
      <ProtectedRoute>
        <React.Suspense fallback={<main>ConceptOne wird geladen …</main>}>
          <ConceptOneApp />
        </React.Suspense>
      </ProtectedRoute>
    ),
  }
]);

if (isDevelopment) {
  pathDefinitionsX.push({
    path: "/c1-eloitems",
    element: (
      <ProtectedRoute>
        <React.Suspense fallback={<main>EloItem-Editor wird geladen …</main>}>
          <ConceptOneApp />
        </React.Suspense>
      </ProtectedRoute>
    ),
  });
}

const router = createBrowserRouter(pathDefinitionsX, {
  basename: "/",
});

const conceptOneSharedPaths = new Set([
  "/register",
  "/verify",
  "/createPassword",
  "/forget-password",
  "/reset-password",
  "/unsubscribe",
  "/shop",
  "/selfservice",
]);

const conceptOnePathDefinitions = PathDefinitions()
  .filter((definition) => conceptOneSharedPaths.has(definition.path))
  .concat([
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/concept-one",
      element: (
        <ProtectedRoute>
          <React.Suspense fallback={<main>ConceptOne wird geladen …</main>}>
            <ConceptOneApp />
          </React.Suspense>
        </ProtectedRoute>
      ),
    },
  ]);

const conceptOneRouter = createBrowserRouter(conceptOnePathDefinitions, {
  basename: "/",
});

mountReactApp(document.getElementById("root")!, () => (
  <React.Profiler id="app" onRender={onReactRender}>
    <Root />
  </React.Profiler>
));
